import { listItemActionRegistry } from 'sulu-admin-bundle/views';
import CloneEntityAction from "./listItemActions/CloneEntityAction";

/*
 * Register list actions.
 */
listItemActionRegistry.add('app.clone.entity', CloneEntityAction);
